export enum DtgActionType {
    create
    ,update
    ,read
    ,delete
    ,ok
    ,cancel
};